import {
  ReactNode,
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  useEffect,
} from 'react';
import { toast } from 'react-toastify';

import { META_COLLECT_API } from '../../../api';
import { BondCollect } from '../../../types/BondCollect';
import { CollectItem } from '../../../types/CollectItem';
import { deformatDate } from '../../../utils/date/deformatDate';
import { useSigninContext } from '../../AuthProviderPages/Signin';
import { usePageContext } from '../../usePage';

interface IContextProps {
  children: ReactNode;
}

interface ILoadCollectItensOfASelectedCollect {
  setLoadCollectItens: Dispatch<SetStateAction<boolean>>;
  setCollectItens: Dispatch<SetStateAction<CollectItem[]>>;
  currentCollectId: string;
}
interface IHandleUnbondCollectItem {
  setLoadAction: Dispatch<SetStateAction<boolean>>;
  executeLoadCollectItensOfASelectedCollect: () => void;
}
interface IContext {
  openSideModalFilterBondCollect: boolean;
  openSideModalFilterBondCollectAction: () => void;

  DFNOMECARRETEIRO: string;
  setDFNOMECARRETEIRO: Dispatch<SetStateAction<string>>;
  DFORDEMCOLETA: string;
  setDFORDEMCOLETA: Dispatch<SetStateAction<string>>;
  DFNOMELINHA: string;
  setDFNOMELINHA: Dispatch<SetStateAction<string>>;
  DFPLACAVEICULO: string;
  setDFPLACAVEICULO: Dispatch<SetStateAction<string>>;
  DFDATACOLETA: string;
  setDFDATACOLETA: Dispatch<SetStateAction<string>>;
  DFDATASAIDA: string;
  setDFDATASAIDA: Dispatch<SetStateAction<string>>;
  DFIDCOLETA: string;
  setDFIDCOLETA: Dispatch<SetStateAction<string>>;
  DFBLOQUEIOERP: string;
  setDFBLOQUEIOERP: Dispatch<SetStateAction<string>>;
  DFTOTALARMAZENADO: string;
  setDFTOTALARMAZENADO: Dispatch<SetStateAction<string>>;
  DFDATAPROGRAMADA: string;
  setDFDATAPROGRAMADA: Dispatch<SetStateAction<string>>;

  filterBondCollectAction: () => void;
  cleanAllInputsAction: () => void;
  loaddingBondCollectAction: () => void;

  openInfo: boolean;
  setOpenInfo: Dispatch<SetStateAction<boolean>>;

  selectedBondCollect: BondCollect | undefined;
  setSelectedBondCollect: Dispatch<SetStateAction<BondCollect | undefined>>;

  bondCollect: BondCollect[];
  setBondCollect: Dispatch<SetStateAction<BondCollect[]>>;
  selectedUnbondCollectItem: CollectItem | undefined;
  setSelectedUnbondCollectItem: Dispatch<
    SetStateAction<CollectItem | undefined>
  >;

  loadingBondCollect: boolean;

  offset: number;
  setOfsset: Dispatch<SetStateAction<number>>;
  limit: number;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  quantity: number;
  setHasClick: Dispatch<SetStateAction<boolean>>;
  start: number;
  setStart: Dispatch<SetStateAction<number>>;

  loadCollectItensOfASelectedCollect: ({
    currentCollectId,
    setLoadCollectItens,
    setCollectItens,
  }: ILoadCollectItensOfASelectedCollect) => void;
  handleUnbondCollectItem: ({
    setLoadAction,
    executeLoadCollectItensOfASelectedCollect,
  }: IHandleUnbondCollectItem) => void;
}

const Context = createContext({} as IContext);

const BondCollectContextProvider = ({ children }: IContextProps) => {
  const [DFNOMECARRETEIRO, setDFNOMECARRETEIRO] = useState<string>('');
  const [DFORDEMCOLETA, setDFORDEMCOLETA] = useState<string>('');
  const [DFNOMELINHA, setDFNOMELINHA] = useState<string>('');
  const [DFPLACAVEICULO, setDFPLACAVEICULO] = useState<string>('');
  const [DFDATACOLETA, setDFDATACOLETA] = useState<string>('');
  const [DFDATASAIDA, setDFDATASAIDA] = useState<string>('');
  const [DFIDCOLETA, setDFIDCOLETA] = useState<string>('');
  const [DFBLOQUEIOERP, setDFBLOQUEIOERP] = useState<string>('');
  const [DFTOTALARMAZENADO, setDFTOTALARMAZENADO] = useState<string>('');
  const [DFDATAPROGRAMADA, setDFDATAPROGRAMADA] = useState<string>('');
  const [loadingBondCollect, setIsLoadingDischargeCollect] =
    useState<boolean>(false);
  const [
    openSideModalFilterBondCollect,
    setOpenSideModalFilterDischargeCollect,
  ] = useState<boolean>(false);
  const [openInfo, setOpenInfo] = useState<boolean>(false);

  const [selectedBondCollect, setSelectedBondCollect] = useState<
    BondCollect | undefined
  >();
  const [bondCollect, setBondCollect] = useState<BondCollect[]>([]);
  const [selectedUnbondCollectItem, setSelectedUnbondCollectItem] =
    useState<CollectItem>();

  const [limit] = useState<number>(50);
  const [offset, setOfsset] = useState<number>(0);
  const [quantity, setQuantity] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [hasClick, setHasClick] = useState<boolean>(false);
  const { path, user } = useSigninContext();
  const { selectedPage } = usePageContext();
  const [start, setStart] = useState(1);

  const Limit = `limit=${limit}`;
  const Offset = `offset=${offset}`;
  const NOMECARRETEIRO = `DFNOMECARRETEIRO=${DFNOMECARRETEIRO}`;
  const ORDEMCOLETA = `DFORDEMCOLETA=${DFORDEMCOLETA}`;
  const NOMELINHA = `DFNOMELINHA=${DFNOMELINHA}`;
  const PLACAVEICULO = `DFPLACAVEICULO=${DFPLACAVEICULO}`;
  const DATACOLETA = `DFDATACOLETA=${deformatDate(DFDATACOLETA)}`;
  const DATASAIDA = `DFDATASAIDA=${deformatDate(DFDATASAIDA)}`;
  const IDCOLETA = `DFIDCOLETA=${DFIDCOLETA}`;
  const BLOQUEIO = `DFBLOQUEIOERP=${DFBLOQUEIOERP}`;
  const TOTALARMAZENADO = `DFTOTALARMAZENADO=${DFTOTALARMAZENADO}`;
  const DATAPROGRAMADA = `DFDATAPROGRAMADA=${deformatDate(DFDATAPROGRAMADA)}`;
  const IDUNIDADE = user?.DFIDUNIDADE
    ? `&DFIDUNIDADE=${user?.DFIDUNIDADE}`
    : '';

  const openSideModalFilterBondCollectAction = () => {
    setOpenSideModalFilterDischargeCollect(!openSideModalFilterBondCollect);
  };

  useEffect(() => {
    if (hasClick) {
      setIsLoadingDischargeCollect(true);
      META_COLLECT_API.get(
        `/coleta/vinculada?${Limit}&${Offset}&${NOMECARRETEIRO}&${ORDEMCOLETA}&${NOMELINHA}&${PLACAVEICULO}&${DATACOLETA}&${DATASAIDA}&${IDCOLETA}&${BLOQUEIO}&${TOTALARMAZENADO}&${DATAPROGRAMADA}${IDUNIDADE}`,
        {
          headers: {
            path,
          },
        },
      )
        .then(response => {
          setBondCollect(response.data.coletas);
          setQuantity(response.data.quantidade);
          setIsLoadingDischargeCollect(false);
          setHasClick(false);
        })
        .catch(() => {
          setIsLoadingDischargeCollect(false);
          setHasClick(false);
        });
    }
  }, [hasClick]);

  const loadUnitsActionWithParams = () => {
    setIsLoadingDischargeCollect(true);
    META_COLLECT_API.get(`/coleta/vinculada?${Limit}&offset=0${IDUNIDADE}`, {
      headers: {
        path,
      },
    })
      .then(response => {
        setBondCollect(response.data.coletas);
        setQuantity(response.data.quantidade);
        setIsLoadingDischargeCollect(false);
        setStart(1);
      })
      .catch(() => {
        setIsLoadingDischargeCollect(false);
        setStart(1);
      });
  };

  const executeCleanInputs = () => {
    setDFNOMECARRETEIRO('');
    setDFORDEMCOLETA('');
    setDFNOMELINHA('');
    setDFPLACAVEICULO('');
    setDFDATACOLETA('');
    setDFDATASAIDA('');
    setOpenInfo(false);
    setDFBLOQUEIOERP('');
    setDFTOTALARMAZENADO('');
    setDFDATAPROGRAMADA('');
  };

  const cleanAllInputsAction = () => {
    executeCleanInputs();
    openSideModalFilterBondCollectAction();
    loadUnitsActionWithParams();
    setPage(1);
    setStart(1);
  };

  const filterBondCollectAction = () => {
    setOfsset(0);
    setPage(1);
    openSideModalFilterBondCollectAction();
    setIsLoadingDischargeCollect(true);
    META_COLLECT_API.get(
      `/coleta/vinculada?${Limit}&offset=0&${NOMECARRETEIRO}&${ORDEMCOLETA}&${NOMELINHA}&${PLACAVEICULO}&${DATACOLETA}&${DATASAIDA}&${IDCOLETA}&${BLOQUEIO}&${TOTALARMAZENADO}&${DATAPROGRAMADA}${IDUNIDADE}`,
      {
        headers: {
          path,
        },
      },
    )
      .then(response => {
        setBondCollect(response.data.coletas);
        setQuantity(response.data.quantidade);
        setIsLoadingDischargeCollect(false);
        setStart(1);
      })
      .catch(() => {
        setIsLoadingDischargeCollect(false);
        setStart(1);
      });
  };

  const loaddingBondCollectAction = () => {
    setIsLoadingDischargeCollect(true);
    loadUnitsActionWithParams();
  };

  useEffect(() => {
    if (selectedPage.option !== 'vinculada') {
      executeCleanInputs();
      setOfsset(0);
      setPage(1);
      setStart(1);
    }
  }, [selectedPage]);

  useEffect(() => {
    if (user?.DFIDUNIDADE) {
      loaddingBondCollectAction();
    }
  }, [user]);

  const loadCollectItensOfASelectedCollect = ({
    setLoadCollectItens,
    currentCollectId,
    setCollectItens,
  }: ILoadCollectItensOfASelectedCollect) => {
    setLoadCollectItens(true);
    META_COLLECT_API.get(
      `/itemcoleta/vinculado?DFIDCOLETA=${currentCollectId}`,
      {
        headers: {
          path,
        },
      },
    )
      .then(res => {
        setCollectItens(res.data.itensColeta);
        setLoadCollectItens(false);
      })
      .catch(() => {
        setLoadCollectItens(false);
      });
  };

  const handleUnbondCollectItem = ({
    setLoadAction,
    executeLoadCollectItensOfASelectedCollect,
  }: IHandleUnbondCollectItem) => {
    setLoadAction(true);
    META_COLLECT_API.patch(
      '/produtorcoleta/desvincular',
      { DFIDITEMCOLETA: selectedUnbondCollectItem?.DFIDITEMCOLETA },
      {
        headers: {
          path,
        },
      },
    )
      .then(() => {
        setLoadAction(false);
        toast.success('Tanque desvinculado com sucesso!');
        executeLoadCollectItensOfASelectedCollect();
      })
      .catch(() => {
        toast.error('Ocorreu um erro inesperado durante a operação!');
        setLoadAction(false);
      });
  };

  return (
    <Context.Provider
      value={{
        cleanAllInputsAction,
        DFORDEMCOLETA,
        filterBondCollectAction,
        loaddingBondCollectAction,
        limit,
        loadingBondCollect,
        offset,
        openInfo,
        openSideModalFilterBondCollect,
        openSideModalFilterBondCollectAction,
        page,
        quantity,
        setHasClick,
        setOfsset,
        setOpenInfo,
        setPage,
        setBondCollect,
        DFDATACOLETA,
        DFDATASAIDA,
        DFNOMECARRETEIRO,
        DFNOMELINHA,
        DFPLACAVEICULO,
        DFIDCOLETA,
        bondCollect,
        selectedBondCollect,
        setDFDATACOLETA,
        setDFDATASAIDA,
        setDFNOMECARRETEIRO,
        setDFNOMELINHA,
        setDFORDEMCOLETA,
        setDFPLACAVEICULO,
        setSelectedBondCollect,
        setDFIDCOLETA,
        start,
        setStart,
        DFBLOQUEIOERP,
        DFTOTALARMAZENADO,
        setDFBLOQUEIOERP,
        setDFTOTALARMAZENADO,
        DFDATAPROGRAMADA,
        setDFDATAPROGRAMADA,
        loadCollectItensOfASelectedCollect,
        selectedUnbondCollectItem,
        setSelectedUnbondCollectItem,
        handleUnbondCollectItem,
      }}
    >
      {children}
    </Context.Provider>
  );
};

function useBondCollectContext() {
  const context = useContext(Context);
  return context;
}

export { BondCollectContextProvider, useBondCollectContext };
